import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { deleteHierarchyItem, deleteModalVisibleUpdated } from 'store/entities/hierarchy/hierarchy';
import translations from 'src/internationalisation/translation-map.json';
import { HierarchyLevelType } from 'src/enums/hierarchy.ts';
import type { TRootState } from 'store/store-types';

type DeleteModalProps = PropsFromRedux & {
  companyId: string;
};

const DeleteModal = ({
  deleteHierarchyItem,
  deleteModalVisibleUpdated,
  selectedId,
  selectedType,
  companyId,
}: DeleteModalProps) => {
  const { t } = useTranslation();
  const onClose = () => deleteModalVisibleUpdated(false);
  const onDelete = () => {
    deleteHierarchyItem(companyId, selectedType as HierarchyLevelType, selectedId as string);
    sessionStorage.removeItem('activeProject');
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <Modal visible centered>
      <Dialog
        dialog={{
          heading: `${t(translations.delete)} ${selectedType}`,
          content: (
            <>
              {t(translations.projects_areYouSureYouWantToDeleteThis, {
                selectedList: selectedType,
              })}
            </>
          ),
          footer: (
            <>
              <Button label={t(translations.delete)} colored onClick={onDelete} testId="delete-modal-button-delete" />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapStateToProps = ({ entities }: TRootState) => {
  const {
    hierarchy: { selectedId, selectedType },
  } = entities;

  return {
    selectedId,
    selectedType,
  };
};
const mapDispatchToProps = { deleteHierarchyItem, deleteModalVisibleUpdated };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = withErrorBoundary(connector(DeleteModal), {
  style: { position: 'absolute', bottom: 0, zIndex: 1000 },
});

export { Container as DeleteModal };
